import React, { useState } from 'react';

import { Alert } from 'antd';
import styled from 'styled-components';

import Button from 'components/lib/Button';
import { RecommendationCommunityOverviewType } from 'types/recommendations';

import useRecommendationDetailsContext from './RecommendationDetailsContext';
import RecommendationEvidenceModal from './RecommendationEvidenceModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
`;

type Props = { data: RecommendationCommunityOverviewType };

const RecommendationFailedCommunity = ({ data }: Props) => {
  const { recommendation } = useRecommendationDetailsContext();
  const [open, setOpen] = useState(false);

  return (
    <Container>
      <Alert
        type="warning"
        showIcon
        message={`${data.community_name}: website insight verification failed`}
        description="Open the collected evidence to see why this insight could not be verified."
      />
      <Button onClick={() => setOpen(true)} data-test-id={`aici-failed-website-evidence-button-${data.community_id}`}>
        Website evidence
      </Button>
      <RecommendationEvidenceModal
        open={open}
        recommendationId={recommendation.id}
        communityId={data.community_id}
        communityName={data.community_name}
        onClose={() => setOpen(false)}
      />
    </Container>
  );
};

export default RecommendationFailedCommunity;
